import React from 'react';
import { Box, Typography, Button, Stack, Grid, CardMedia } from '@mui/material';
import { HomeownerPortalWrapper } from '../components/homeowner-portal-wrapper';
import communityHero from '../../../assets/homeowner-portal/my_community_hero.webp';
import { HeroSection, BuildsDropdown } from '../components';
import { BlueBackgroundWrapper } from '../components/blue-background-wrapper';
import { ExternalLink } from '../../../components';
import nonHOAImage from '../../../assets/homeowner-portal/non_hoa_need_help.jpg';
import hoaImage from '../../../assets/homeowner-portal/hoa_need_help.jpg';
import hoaAlabamaLogo from '../../../assets/logos/hoa_alabama.png';
import { useBuilds } from '../context';

export const LearnMoreAboutMyCommunity = () => {
  const { isHoaal } = useBuilds();
  return (
    <HomeownerPortalWrapper title="Learn More About My Community">
      <Box sx={{ flex: 1 }}>
        <HeroSection
          image={communityHero}
          title="Learn More About My Community"
          subtitle="All the information you need for your new community"
          variant="small"
          backgroundPosition="0 35%"
        />
        <Box sx={{ mt: 3, mx: 4 }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={12} md={8}>
              {/* Empty space to match layout structure */}
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                display: 'flex',
                justifyContent: { xs: 'flex-start', md: 'flex-end' },
                mt: { xs: 2, md: 0 }
              }}
            >
              <BuildsDropdown sx={{ minWidth: { xs: '100%', md: 280 } }} />
            </Grid>
          </Grid>
        </Box>
        <Stack gap={4} mt={3}>
          {/** Contact HOA Alabama section */}
          {isHoaal && (
            <BlueBackgroundWrapper>
              <Grid container spacing={4} alignItems="center" py={1}>
                <Grid item xs={12} md={4}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      pb: { xs: 0, md: 5 }
                    }}
                  >
                    <img
                      src={hoaAlabamaLogo}
                      alt="HOA Alabama"
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                        maxHeight: '100px'
                      }}
                    />
                    <Button
                      variant="contained"
                      component={ExternalLink}
                      to="https://www.hoaal.com"
                      type="white"
                      target="_blank"
                      sx={{ width: { xs: '100%', md: '250px' } }}
                    >
                      Contact HOA Alabama
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 3,
                      lineHeight: 1.6,
                      color: '#333'
                    }}
                  >
                    We're proud to partner with HOA Alabama to help ensure our communities are
                    wellmanaged, welcoming, and beautifully maintained. Their dedication to
                    excellence and homeowner satisfaction aligns perfectly with our commitment to
                    creating neighborhoods that feel like home. Together, we're building more than
                    just houses— we're building community.
                  </Typography>
                </Grid>
              </Grid>
            </BlueBackgroundWrapper>
          )}
          <Grid
            container
            spacing={3}
            sx={{ paddingLeft: theme => theme.spacing(3), paddingRight: theme => theme.spacing(3) }}
          >
            <Grid item xs={12} md={6}>
              <Typography mb={2}>
                Need Help? {isHoaal ? 'HOA Alabama is Here for You!' : ''}
              </Typography>
              <Typography variant="body1" sx={{ fontStyle: 'italic' }} mb={1}>
                As a trusted partner in your community, {isHoaal ? 'HOA Alabama' : '---'} is your
                go-to resource for all things related to your neighborhood's Homeowners Association.
              </Typography>
              <Typography variant="body1" sx={{ fontStyle: 'italic' }} mb={1}>
                Here are just a few of the things you can reach out to them about:
              </Typography>
              <ul>
                <li>
                  <Typography variant="body1" component="span">
                    Amenity Access - Questions about pool keys, clubhouse reservations, or amenity
                    hours? They've got you covered.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" component="span">
                    Dues & Payments - Need help with HOA dues, billing questions, or setting up your
                    payment portal? They're happy to assist.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" component="span">
                    Community Guidelines - Not sure about the rules for fences, landscaping, or
                    exterior updates? --- can guide you.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" component="span">
                    Maintenance Requests - Spot something in a common area that needs attention? Let
                    them know!
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" component="span">
                    General Questions - Whether you're new to the neighborhood or just need a quick
                    answer, they're always ready to help.
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} md={6}>
              <CardMedia
                component="img"
                image={isHoaal ? hoaImage : nonHOAImage}
                alt="Kid playing"
                sx={{ height: '100%', width: '100%', objectFit: 'cover' }}
              />
            </Grid>
          </Grid>
          <BlueBackgroundWrapper>
            <Typography mb={2}>Neighborhood Security with Flock Safety</Typography>
            <Typography mb={2}>
              Your safety and peace of mind matter to us. That's why many of our communities are
              protected by Flock Safety, a license plate- reading camera system designed to help
              deter crime and support law enforcement when needed. These smart cameras track vehicle
              activity entering and exiting the neighborhood—creating a safer environment for you
              and your family. Flock is just one of the ways we're working to build not only homes,
              but strong, secure communities.
            </Typography>
            <Button
              variant="contained"
              component={ExternalLink}
              to="https://www.flocksafety.com/"
              type="white"
              target="_blank"
            >
              Learn More
            </Button>
          </BlueBackgroundWrapper>
        </Stack>
      </Box>
    </HomeownerPortalWrapper>
  );
};
